// import React, { useEffect, useState } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import SweetAlert from '../../Shared/Notification';
// import APIService from '../../../Services/APIService';
// import TableHeader from '../../Shared/TableHeader';
// import CommonTable from '../../Shared/Tables';
// import SearchBox from '../../Shared/SearchBox/index';
// import { Row, Col, Button } from 'react-bootstrap';
// import LoadingWrapper from '../../Shared/LoadingWrapper/index';
// import DataNotFound from '../../Shared/DataNotFound';
// import ReactPagination from '../../Shared/Pagination';
// import ConfirmBox from '../../Shared/Notification/ConfirmBox';

// const SupplierList = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading] = useState(false);
//   const [list, setList] = useState([]);
//   const [filters, setFilters] = useState({ search: '', page: 0, totalCount: 0 });

//   const getSupplierList = async (data) => {
//     setIsLoading(true);
//     let res = await APIService.get(
//       `/v0/ui/dynamic-suppliers/supplier/?page=${data?.page + 1}&search=${data?.search}`
//     );
//     if (res.status == 200) {
//       setList(Object.values(res?.data?.list));
//       setFilters({ ...filters, totalCount: res?.data?.count, page: data?.page });
//     }
//     setIsLoading(false);
//   };

//   useEffect(() => {
//     getSupplierList(filters);
//   }, []);

//   const onSearchFilterChange = (event) => {
//     getSupplierList({ ...filters, search: event });
//   };

//   const onRemoveSupplier = async (id, index) => {
//   const confirmed = await ConfirmBox({
//     title: 'Confirm Deletion',
//     text: 'Are you sure you want to delete this supplier?',
//     icon: 'warning',
//   });
//   if (confirmed) {
//     let res = await APIService.remove(`/v0/ui/dynamic-suppliers/supplier/${id}/`);
//     if (res.status == 200) {
//       let data = list;
//       data.splice(index, 1);
//       setList([...data]);
//       SweetAlert('Supplier deleted successfully', 'success');
//     }
//   }
//   };

//   const onPageChange = (e) => {
//     getSupplierList({ ...filters, page: e?.selected });
//   };

//   const columns = [
//     {
//       dataField: 'index',
//       text: 'S.No.',
//       formatter: (cell, row, rowIndex) => filters?.page * 20 + rowIndex + 1,
//       headerAlign: 'center',
//       align: 'center',
//     },
//     {
//       dataField: 'name',
//       text: 'Name',
//       headerAlign: 'center',
//       align: 'center',
//     },
//     {
//       dataField: 'action',
//       text: 'Action',
//       headerAlign: 'center',
//       align: 'center',
//       formatter: (cell, row, rowIndex) => {
//         return (
//           <>
//             <Link to={`/r/supplier/edit/${row.id}`} className="btn btn--danger">
//               <span>
//                 <svg
//                   xmlns="http://www.w3.org/2000/svg"
//                   width="16"
//                   height="16"
//                   fill="currentColor"
//                   className="bi bi-pencil-fill"
//                   viewBox="0 0 16 16"
//                 >
//                   <path d="M12.854.146a.5.5 0 0 0-.707 0L10.5 1.793 14.207 5.5l1.647-1.646a.5.5 0 0 0 0-.708zm.646 6.061L9.793 2.5 3.293 9H3.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.207zm-7.468 7.468A.5.5 0 0 1 6 13.5V13h-.5a.5.5 0 0 1-.5-.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.5-.5V10h-.5a.5.5 0 0 1-.175-.032l-.179.178a.5.5 0 0 0-.11.168l-2 5a.5.5 0 0 0 .65.65l5-2a.5.5 0 0 0 .168-.11z" />
//                 </svg>
//               </span>
//             </Link>
//             <span
//               style={{ cursor: 'pointer' }}
//               onClick={(e) => onRemoveSupplier(row?.id, rowIndex)}
//             >
//               <svg
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="16"
//                 height="16"
//                 fill="currentColor"
//                 className="bi bi-trash-fill"
//                 viewBox="0 0 16 16"
//               >
//                 <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5M8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5m3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0" />
//               </svg>
//             </span>
//           </>
//         );
//       },
//     },
//   ];

//   return (
//     <>
//       <TableHeader headerValue={'Supplier List'} />
//       <Row>
//         <Col xs="3" className="pb-2">
//           <SearchBox onSearch={onSearchFilterChange} value={filters?.search} />
//         </Col>{' '}
//         <Col xs="3" className="pb-2">
//           <Button
//             onClick={() => {
//               navigate('/r/supplier/create');
//             }}
//           >
//             Create Supplier
//           </Button>
//         </Col>{' '}
//       </Row>
//       {isLoading ? (
//         <LoadingWrapper />
//       ) : list?.length > 0 ? (
//         <>
//           <CommonTable id={'id'} columnsData={columns} rowData={list} />
//           <ReactPagination
//             pageNo={filters?.page}
//             pageSize={20}
//             totalItems={filters?.totalCount}
//             onPageChange={onPageChange}
//           />
//         </>
//       ) : (
//         <DataNotFound />
//       )}
//     </>
//   );
// };
// export default SupplierList;

import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import APIService from '../../../Services/APIService';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import SearchBox from '../../FlowBuilder/Common/SearchBox/index.tsx';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Pagination from '../../FlowBuilder/Common/Pagination/index.tsx';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx';
import useDebounce from '../../Shared/Delay/index.tsx';

const SupplierList = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [list, setList] = useState([]);
  const [filters, setFilters] = useState({ search: '', page: 0, totalCount: 0, limit: 20 });
  const [searchFilter, setSearchFilter] = useState('');
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState({ id: null, index: null });
  const { showSnackBar } = useSnackBar();
  const debouncedSearch = useDebounce(filters.search, 500);

  const getSupplierList = async (data) => {
    setIsLoading(true);
    const res = await APIService.get(
      `/v0/ui/dynamic-suppliers/supplier/?page=${data?.page + 1}&pageSize=${data?.limit}&search=${data?.search}`
    );
    if (res.status === 200) {
      setList(Object.values(res?.data?.list));
      setFilters({
        ...filters,
        totalCount: res?.data?.count,
        page: data?.page,
        limit: data?.limit,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getSupplierList({ ...filters, search: debouncedSearch });
  }, [debouncedSearch, filters.page, filters.limit]);

  const onSearchFilterChange = (value) => {
    setFilters((prev) => ({
      ...prev,
      search: value,
      page: 0,
    }));
  };

  const onRemoveSupplier = (id, index) => {
    setSelectedSupplier({ id, index });
    setConfirmDialogOpen(true);
  };

  const handleConfirmClose = async (confirmed) => {
    setConfirmDialogOpen(false);

    if (confirmed && selectedSupplier.id != null) {
      const res = await APIService.remove(
        `/v0/ui/dynamic-suppliers/supplier/${selectedSupplier.id}/`
      );
      if (res.status === 200) {
        const newList = [...list];
        newList.splice(selectedSupplier.index, 1);
        setList(newList);
        showSnackBar('Supplier deleted successfully', 'success');
      }
    }
    setSelectedSupplier({ id: null, index: null });
  };

  const handleChangePage = (event, newPage) => {
    const updatedFilters = { ...filters, page: newPage };
    setFilters(updatedFilters);
    getSupplierList(updatedFilters);
  };

  const handleChangeRowsPerPage = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const updatedFilters = { ...filters, page: 0, limit: newLimit };
    setFilters(updatedFilters);
    getSupplierList(updatedFilters);
  };

  const columns = [
    {
      accessorKey: 'index',
      header: 'S.No.',
      enableSorting: false,
      size: 50,
      Cell: ({ row }) => filters.page * 20 + row.index + 1,
    },
    {
      accessorKey: 'name',
      header: 'Name',
      enableSorting: false,
      size: 50,
    },
    {
      accessorKey: 'actions',
      header: 'Action',
      size: 70,
      enableSorting: false,
      Cell: ({ row }) => {
        return (
          <Box display="flex" gap={1}>
            <IconButton component={Link} to={`/r/supplier/edit/${row.original.id}`} size="small">
              <EditIcon fontSize="small" />
            </IconButton>
            <IconButton size="small" onClick={() => onRemoveSupplier(row.original.id, row.index)}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Box>
        );
      },
    },
  ];

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', p: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold">
            Supplier List
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{ alignItems: 'center', pt: 2, pb: 2.5, gap: 2 }}
        className="search-box-style"
      >
        <Grid item xs={12} sm={6} md={2}>
          <SearchBox handleSearch={onSearchFilterChange} value={filters?.search} />
        </Grid>
        <Grid item xs={12} sm={6} md={2}>
          <Button
            variant="contained"
            size="small"
            color="primary"
            onClick={() => {
              navigate('/r/supplier/create');
            }}
          >
            Create Supplier
          </Button>
        </Grid>
      </Grid>
      <CommonTable
        columns={columns}
        data={list}
        isLoading={isLoading}
        renderBottomToolbar={() => (
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0 }}>
            <Pagination
              totalCount={filters?.totalCount}
              rowsPerPage={filters?.limit}
              page={filters?.page}
              handleChangePage={handleChangePage}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Box>
        )}
      />
      <ConfirmBox
        open={confirmDialogOpen}
        onClose={handleConfirmClose}
        options={{
          title: 'Confirm Deletion',
          text: 'Are you sure you want to delete this supplier?',
          confirmButtonText: 'Delete',
          confirmButtonColor: 'error',
          cancelButtonText: 'Cancel',
          cancelButtonColor: 'secondary',
        }}
      />
    </Box>
  );
};
export default SupplierList;
